import { Typography, Box, FormControlLabel, Switch, styled, Button } from '@mui/material'
import React, {useState} from 'react'
import { CustomInput } from '../../../components-new/common'
import { useUpdateErrorHandlingMutation } from '../../../useQuery'
import { useNotification } from '../../../hooks'


const ErrorHandling = ({item}) => {
  const [errorMessage, setErrorMessage] = useState(item.app_error_message)
  const [errorCode, setErrorCode] = useState(item.app_error_code)
  const [hasAppError, setHasAppError] = useState(item.has_app_error === "true" ? true : false)
  const [tag, setTag] = useState(item.tag)
  const notify = useNotification()
  const {mutate: updateErrorHandling} = useUpdateErrorHandlingMutation({
    onSuccess: () => {
      notify("Error Handling updated successfully", "success")
    },
    onError: () => {
      notify("Error Handling update failed", "error")
    }
  })



const StyledButton = styled(Button)`
  padding: 15px 28px;
  border-radius: 8px;
  text-transform: capitalize;
`;


const handleSubmit = () => {
  updateErrorHandling({
    has_app_error: hasAppError ? "true" : "false",
    app_error_message: errorMessage,
    app_error_code: errorCode,
    tsid: item.idtest_step,
    tag: tag,
  })
}
  return (
    <Box>
      <Typography variant='h6'>Error Handling</Typography>
      <Box sx={{
        display: "flex",
        flexDirection:"row",
        alignItems:"center",
        gap: "30px",
        mt: "20px",
      }}>
        <FormControlLabel control={
          <Switch checked={hasAppError} 
          onChange={(e) => {
              setHasAppError(e.target.checked)
            }}
          />
        }
        label="Has App Error"
        />
        <CustomInput 
        placeholder="Error Message"
        value={errorMessage}
        onChange={(e) => {
          setErrorMessage(e.target.value)
        }}
        />
        <CustomInput 
        placeholder="Error Code"
        value={errorCode}
        onChange={(e) => {
          setErrorCode(e.target.value)
        }}
        />
        <CustomInput 
        placeholder="Tag"
        value={tag}
        onChange={(e) => {
          setTag(e.target.value)
        }}
        />
      <StyledButton variant='contained' color='primary' onClick={handleSubmit}>
        Save
      </StyledButton>
      </Box>

    </Box>
  )
}

export default ErrorHandling